<template>
  <v-container>
    <v-btn fixed dark fab bottom right color="pink" @click="createNew">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-data-table :items="receipts" :headers="headers" :loading="isBusy" item-key="id"
                  @click:row="editSelected" disable-pagination hide-default-footer
                  fixed-header disable-sort class="row-pointer">
      <template v-slot:item.timestamp="{ item }">
        <span>{{ $moment(item.timestamp).format('YYYY-MM-DD') }}</span>
      </template>
      <template v-slot:item.values="{ item }">
        <div v-for="v in item.values" :key="v.id">
          {{ counterValues(v) }}
        </div>
      </template>
      <template v-slot:item.isSent="{ item }">
        <v-icon>{{ item.isSent === true ? "mdi-checkbox-marked-outline" : "mdi-checkbox-blank-outline" }}</v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

export default {
  name: 'Receipts',
  data() {
    return {
      isBusy: false,
      headers: [
        {value: 'timestamp', text: 'Дата'},
        {value: 'values', text: 'Показания счетчиков'},
        {value: 'isSent', text: 'Отправлены?', align: 'center'},
      ],
      receipts: [],
      counters: []
    }
  },
  mounted() {
    this.isBusy = true
    this.$http("/counter")
        .then(resp => {
          this.counters = resp.data.reduce(function(map, obj) {
            map[obj.id] = obj
            return map
          }, {})
          return this.$http("/receipt")
        })
        .then(resp => this.receipts = resp.data)
        .finally(() => this.isBusy = false)
  },
  methods: {
    counterValues(value) {
      const type = this.counters[value.counterId].type
      let result = {
        "WATER_HOT": "Горячая вода",
        "WATER_COLD": "Холодная вода",
        "ELECTRO_1": "Электричество",
        "ELECTRO_2": "Электричество",
        "ELECTRO_3": "Электричество",
      }[type] ?? type
      result += `, ${this.counters[value.counterId].title}: `
      if (type === "ELECTRO_2") {
        result += `${value.value_1} / ${value.value_2}`
      } else if(type === "ELECTRO_3") {
        result += `${value.value_1} / ${value.value_2} / ${value.value_3}`
      } else {
        result += value.value_1
      }
      return result
    },
    createNew: function () {
      this.$router.push({name: 'ReceiptCreate'})
    },
    editSelected: function (item) {
      this.$router.push({name: 'ReceiptEdit', params: {receiptId: item.id}})
    }
  }
}

</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>